module.exports = __webpack_public_path__ + "img/download.f3884dfc.svg";